import { render, staticRenderFns } from "./HomeBannerButton.vue?vue&type=template&id=03999a88&scoped=true&"
import script from "./HomeBannerButton.vue?vue&type=script&lang=js&"
export * from "./HomeBannerButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03999a88",
  null
  
)


    import installComponents from "!/Users/jurajpetras/dev/pmat/web/frontend/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BButton, BCol} from 'bootstrap-vue'
    installComponents(component, {BButton, BCol})
    

export default component.exports